//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from "vue";
import { ObserveVisibility } from "vue-observe-visibility";

export default Vue.extend({
  data: function () {
    return {};
  },
  directives: {
    ObserveVisibility,
  },
});
